import { VCol } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        VCol,
        [
          _c(VPagination, {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  (_vm.pageType === "2" && _vm.pagination.total > 0) ||
                  (_vm.pageType === "1" &&
                    (_vm.pagination.current > 1 || _vm.pagination.next)),
                expression:
                  "(pageType === '2' && pagination.total > 0) || (pageType === '1' && (pagination.current > 1 || pagination.next))",
              },
            ],
            attrs: {
              length: _vm.getTotalPages,
              circle: "",
              "total-visible": 5,
            },
            on: { input: _vm.goPage },
            model: {
              value: _vm.pagination.current,
              callback: function ($$v) {
                _vm.$set(_vm.pagination, "current", $$v)
              },
              expression: "pagination.current",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }